<div *ngIf="errorMessages.length > 0">
  <p-messages severity="error">
    <ng-template pTemplate>
      <ul>
        <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
      </ul>
    </ng-template>
  </p-messages>
</div>
<div class="prerequisites">
    <p-fieldset legend="Prerequisites" [toggleable]="true" class="first-fieldset">      
      <div *ngFor="let item of prerequisitesDataToDisplay">
        <div class="grid">
          <div class="col-10">
            <span class="">
              <a
                class="ml-3 underline blue-color cursor-pointer overflow-ellipse"
                (click)="openPrerequisites(item.number, item.version, item.prerequisiteType)"
              >
                {{ item.number }} {{ item.title }}
              </a>
            </span>
          </div>
    
          <div class="col-2">
            <em
              class="ml-2 fa fa-trash blue-color cursor-pointer"
              (click)="showConfirmationPopupForDeletedPrerequisites(item.number)"
            ></em>
          </div>
        </div>
      </div>      
        <app-confirmation-dialog *ngIf="showDeletePrerequisiteConfirmationModal" 
        [messageForApprovedAndEffcetivePhases]="prerequisiteDeletedMessage" 
        (confirmed)="updateSelectedData()" 
        (dialogClosed)="closeConfirmationModal()">
        </app-confirmation-dialog>
    </p-fieldset> 
    <p-fieldset legend="Search Training Items" [toggleable]="true"  class="second-fieldset">
        <div class="second-fieldset-content">
         <p-tabView [(activeIndex)]="innerActiveIndex" (onChange)="onInnerTabChange($event)">
          <p-tabPanel header="Document">
          <ng-container *ngIf="shouldLoadDocSearch">

            <div class="m-1">
              <app-document-library-search
                #docSearch
                (shouldAddLinkItemsButtonDisplayed)="isAddPrerequisiteDocButtonVisible = $event"
                (emitSelectedData)="docPrerequisiteSelectedData($event)"
                [panelListScreen]="coursePrerequisitesTab">
              </app-document-library-search>
            </div>

            <div class="col mb-2" *ngIf="isAddPrerequisiteDocButtonVisible">
              <p-button
                appPreventDoubleClick
                label="Add Prerequisites"
                icon="fa fa-plus"
                id="addCourseItemButton"
                styleClass="p-button-outlined"
                iconPos="left"
                pTooltip="Add Prerequisites"
                (debounceClick)="addDocumentItems(docSearch)"
                [disabled]="!isDocRecordSelected">
              </p-button>
            </div>

          <app-confirmation-dialog
          *ngIf="showeQMSScopeValidationModal"
          [messageForApprovedAndEffcetivePhases]="eQMSScopeConfirmationMessage"
          (confirmed)="displayDocuments(1, docSearch)"
          (dialogClosed)="closeConfirmationModalForeQMSScopeValidation()">
        </app-confirmation-dialog>

  </ng-container>
</p-tabPanel>

 <p-tabPanel header="Course">
  <ng-container *ngIf="shouldLoadCourseSearch">

    <div class="content">
      <app-course-catalogue-search
        #courseSearch
        (shouldAddTrainingItemAsCourseButtonDisplayed)="isAddPrerequisiteCourseButtonVisible = $event"
        (emitSelectedData)="courseItemsSelectedData($event)"
        [enableCheckBoxes]="showCheckBoxes"
        [panelListScreen]="panelListScreen">
      </app-course-catalogue-search>
    </div>

    <div class="col mb-2" *ngIf="isAddPrerequisiteCourseButtonVisible">
      <p-button
        appPreventDoubleClick
        label="Add Prerequisites"
        icon="fa fa-plus"
        id="addCourseItemButton"
        styleClass="p-button-outlined"
        iconPos="left"
        pTooltip="Add Prerequisites"
        (debounceClick)="addCourseItems(courseSearch)"
        [disabled]="!isCourseRecordSelected">
      </p-button>
    </div>

    <app-confirmation-dialog
      *ngIf="showeQMSScopeValidationModal"
      [messageForApprovedAndEffcetivePhases]="eQMSScopeConfirmationMessage"
      (confirmed)="displayDocuments(2, courseSearch)"
      (dialogClosed)="closeConfirmationModalForeQMSScopeValidation()">
    </app-confirmation-dialog>

  </ng-container>
</p-tabPanel>

        </p-tabView>
        </div>
    </p-fieldset>   
</div> 
<div class="button">
    <p-button
    appPreventDoubleClick
    label="Previous"
    type="submit"
    id="coursePrerequisitePreviousBtn"
    class="align-left"
    styleClass="bpt-button-compact"
    (debounceClick)="openPreviousTab()"
    >
    </p-button>
      <p-button appPreventDoubleClick *ngIf="isEditSlider"
        label="Save"
        type="submit"
        id="coursePrerequisiteBtnSave"
        class="saveBtn"
        styleClass="bpt-button-compact"
        (debounceClick)="saveCourse()"
      >
      </p-button>
      <p-button 
      appPreventDoubleClick
      label="Next"
      type="submit"
      id="coursePrerequisiteBtnNext"
      styleClass="bpt-button-compact"
      class="align-right mr-3"
      (debounceClick)="openNextTab()"
    >
    </p-button>
</div>

<app-confirmation-dialog *ngIf="isInActiveAssignmentGroupDialog" [InactiveAssignmentGroupField]= "InactiveAssignmentGroupField"  (confirmed)="saveDocumentwithInactiveAssignmentGroup()" (dialogClosed)="closeConfirmationDailog($event)"></app-confirmation-dialog>
